// Pathify
import { make } from "vuex-pathify";
import { i18n } from "@/plugins/i18n.js";

// Data
const state = {
  enableDebugMode: false,
  vstoMode: false,
  isLogined: false,
  drawerImage: true,
  showDrawer: false,
  image: "",
  dark: false,
  mini: false, // true-侧边导航收起
  version: "1.0",
  name: "",
  items: [
    {
      id: "",
      title: i18n.t("main.title_menu_gpt"),
      icon: "mdi-chat",
      to: "/gpt",
      badge: 0,
      badgeColor: "error",
    },
    {
      id: "",
      title: i18n.t("main.title_menu_template"),
      icon: "mdi-file-multiple",
      to: "/template",
      badge: 0,
      badgeColor: "error",
    },
    {
      id: "",
      title: i18n.t("main.title_menu_canvas"),
      icon: "mdi-pencil",
      to: "/canvas",
      badge: 0,
      badgeColor: "error",
    },
    {
      id: "",
      title: i18n.t("main.title_menu_account"),
      icon: "mdi-account-box",
      to: "/account",
      badge: 0,
      badgeColor: "error",
    },
    {
      id: "",
      title: i18n.t("main.title_menu_gallary"),
      icon: "mdi-wallpaper",
      to: "/gallary",
      badge: 0,
      badgeColor: "error",
    },
  ],
};

const mutations = make.mutations(state);

const getters = make.getters(state);

const actions = make.actions(state);

function resetState() {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,

  resetState,
};
